import React from "react";
import styled from "styled-components";
import AppText from "../../Core/AppText/AppText";

type Size = "s" | "m" | number;

export interface ILoadingIndicator {
	showText?: boolean | string;
	inline?: boolean;
	size?: Size;
	className?: string;
}

const LoadingIndicator: React.FC<ILoadingIndicator> = ({
	showText = true,
	size,
	inline,
	className,
}) => {
	const text = showText && typeof showText === "string" ? showText : "Laddar...";
	return (
		<div
			className={className}
			style={{
				width: inline ? "auto" : "100%",
				display: inline ? "inline-block" : "block",
			}}
		>
			<StyledLoadingIndicator size={size || "m"}>
				<div className="bounce1" />
				<div className="bounce2" />
			</StyledLoadingIndicator>
			{showText && (
				<AppText textAlign="center" className="spinner-text" margin="1rem 0 0 0">
					{text}
				</AppText>
			)}
		</div>
	);
};

export default LoadingIndicator;

const StyledLoadingIndicator = styled.div<{ size: Size }>`
	width: ${({ size }) => getSize(size)};
	height: ${({ size }) => getSize(size)};
	position: relative;
	margin: 0 auto;

	.bounce1,
	.bounce2 {
		width: 100%;
		height: 100%;
		border-radius: 50%;
		background-color: #ddd;
		opacity: 0.6;
		position: absolute;
		top: 0;
		left: 0;
		animation: sk-bounce 2s infinite ease-in-out;
	}

	.bounce2 {
		animation-delay: -1s;
	}

	@-webkit-keyframes sk-bounce {
		0%,
		100% {
			transform: scale(0);
		}
		50% {
			transform: scale(1);
		}
	}

	@keyframes sk-bounce {
		0%,
		100% {
			transform: scale(0);
		}
		50% {
			transform: scale(1);
		}
	}
`;

function getSize(size: Size) {
	if (size === "s") return "20px";
	if (size === "m") return "40px";
	if (typeof size === "number") return size + "px";
	return "40px;";
}
